<template>
  <div
    v-if="image"
    class="text-center p-1"
  >
    <img
      :src="image"
      alt="Powered by"
      draggable="false"
    >
  </div>
</template>

<script>
export default {
  name: 'footerIMS',
  data () {
    return {
      image: ''
    }
  },
  created () {
    if (localStorage.getItem('poweredby')) {
      this.image = localStorage.getItem('poweredby')
    } else {
      const interval = setInterval(() => {
        if (localStorage.getItem('images')) {
          // const images = JSON.parse(localStorage.getItem('images'))
          // var image = images.filter(image => image.keyitem === 'poweredby')
          // this.image = image[0].image
          localStorage.setItem('poweredby', this.image)
          clearInterval(interval)
        }
      }, 200)
    }
  }
}
</script>

<style scoped>
  img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterIMS.vue